let navigateFn;

export const setNavigator = (navigate) => {
  navigateFn = navigate;
};

export const navigate = (path) => {
  if (navigateFn) navigateFn(path);
};
